/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsSignalDimension,
  AnalyticsSignalDimension$inboundSchema,
  AnalyticsSignalDimension$Outbound,
  AnalyticsSignalDimension$outboundSchema,
} from "./analyticssignaldimension.js";

export type AnalyticsSignalFilter = {
  /**
   * Exactly one system field or arbitrary attribute key.
   */
  dimension: AnalyticsSignalDimension;
  /**
   * Comparison from the analytics catalog: equals, in, exists or missing
   */
  operator: string;
  values?: Array<string> | undefined;
};

/** @internal */
export const AnalyticsSignalFilter$inboundSchema: z.ZodMiniType<
  AnalyticsSignalFilter,
  unknown
> = z.object({
  dimension: AnalyticsSignalDimension$inboundSchema,
  operator: z.string(),
  values: z.optional(z.array(z.string())),
});
/** @internal */
export type AnalyticsSignalFilter$Outbound = {
  dimension: AnalyticsSignalDimension$Outbound;
  operator: string;
  values?: Array<string> | undefined;
};

/** @internal */
export const AnalyticsSignalFilter$outboundSchema: z.ZodMiniType<
  AnalyticsSignalFilter$Outbound,
  AnalyticsSignalFilter
> = z.object({
  dimension: AnalyticsSignalDimension$outboundSchema,
  operator: z.string(),
  values: z.optional(z.array(z.string())),
});

export function analyticsSignalFilterToJSON(
  analyticsSignalFilter: AnalyticsSignalFilter,
): string {
  return JSON.stringify(
    AnalyticsSignalFilter$outboundSchema.parse(analyticsSignalFilter),
  );
}
export function analyticsSignalFilterFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalFilter, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalFilter$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalFilter' from JSON`,
  );
}
